import React, { useMemo } from 'react';
import styled from 'styled-components';
import CloseIcon from '@material-ui/icons/Close';
import { colors } from '../../../../../../../constants/colors';
import { fontSize, fontFamily } from '../../../../../../../constants/text';
import { URGENT_CARE_VALUE } from '../../../../../../Home/Tiles/ProviderTypes';

const Root = styled.div.withConfig({ componentId: 'sc-49200y-0' })`
  background-color: ${colors.theWhiteAlbum};
  padding: 25px 30px;
  box-shadow: inset 0 -1px 0 0 ${colors.emptyBarGrey};
  border-bottom: 1px solid ${colors.granite};
`;

const IconCloseContainer = styled.div.withConfig({ componentId: 'sc-49200y-1' })`
  display: flex;
  flex-direction: row;
  align-items: flex-start;
  justify-content: space-between;
  width: 100%;
`;

const Icon = styled.img.withConfig({ componentId: 'sc-49200y-2' })`
  position: relative;
  right: 20px;
  width: 50%;
  margin-bottom: 18px;
`;

const Close = styled(CloseIcon).withConfig({ componentId: 'sc-49200y-3' })`
  font-size: ${fontSize.extraExtraLarge};
  cursor: pointer;
`;

const Title = styled.div.withConfig({ componentId: 'sc-49200y-4' })`
  font-family: ${fontFamily.bold};
  font-size: ${fontSize.mediumLarge};
  color: ${colors.squid};
  line-height: 28px;
  margin-bottom: 10px;
  letter-spacing: 0.3px;
`;

const Description = styled.div.withConfig({ componentId: 'sc-49200y-5' })`
  font-family: ${fontFamily.book};
  font-size: ${fontSize.mediumSmall};
  letter-spacing: 0.25px;
  color: ${colors.blueMonday};
  line-height: 20px;
  padding-bottom: 10px;
  width: 85%;
`;

type Props = {
  closeModal: (...args: any[]) => any;
  providerType?: string;
};

const Header = (props: Props) => {
  const { closeModal, providerType } = props;
  const { icon, title, description } = useMemo(() => {
    switch (providerType) {
      default:
      case URGENT_CARE_VALUE:
        return {
          icon: '/images/insurance/copays/urgent_care.png',
          title: 'Urgent care',
          description:
            'Use for non-life-threatening injuries and illnesses. ' +
            "Treat issues that simply can't wait, like broken bones, colds, or the flu.",
        };
    }
  }, [providerType]);

  return (
    <Root>
      <IconCloseContainer>
        <Icon src={icon} />

        <Close onClick={closeModal} />
      </IconCloseContainer>

      <Title>{title}</Title>

      <Description>{description}</Description>
    </Root>
  );
};

export default Header;
